<template>
  <div class="con">
    <div class="breadcrumb">
      <router-link to="/seller/list">参展商列表</router-link>
      <span>/</span>
      <router-link :to="{path:'/seller/'+ sid +'/product'}">展品列表</router-link>
      <span>/</span>
      {{p.name}}
    </div>

    <div class="flexbox">
      <div class="left">
        <div class="preview">
          <div class="img-box">
            <img :src="imglist[previewIdx]&&imglist[previewIdx].picture" alt="">
            <div class="zoom" @click="zoom"><i class="el-icon-zoom-in"></i></div>
          </div>
          <div class="btn-zoom"></div>
          <!-- <div class="btn">查看视频</div> -->
        </div>
        <ul>
          <li 
            :class="{'active':index===previewIdx}"
            v-for="(item,index) in imglist" 
            :key="index"
            :data-idx="index"
            @click="changeImg"
          >
            <img :src="item.picture" alt="">
          </li>
        </ul>
      </div>
      <div class="right">
        <div class="title">{{p.name}}</div>
        <div class="desp">
          {{p.description}}
        </div>
        <!-- <div class="btn-box">
          <div class=""><Btn title="预约洽谈" icon="el-icon-time" color="red"></Btn></div>
          <div class=""><Btn title="提交意向订单" icon="el-icon-edit-outline"></Btn></div>
        </div> -->
      </div>
    </div>

    <div class="big-title">展品参数</div>
    <ul class="box2">
      <li>
        <span>展品编码：</span>
        <span>{{p.code}}</span>
      </li>
      <li>
        <span>展品尺寸：</span>
        <span>{{p.size}}</span>
      </li>
      <li>
        <span>展品型号：</span>
        <span>{{p.model}}</span>
      </li>
      <li>
        <span>展品材质</span>
        <span>{{p.material}}</span>
      </li>
      <li>
        <span>展品颜色：</span>
        <span>{{p.colour}}</span>
      </li>
      <li>
        <span>展品特征：</span>
        <span>{{p.features}}</span>
      </li>
      <li>
        <span>发货地：</span>
        <span>{{p.departure}}</span>
      </li>
      <li>
        <span>原料生产地：</span>
        <span>{{p.factory}}</span>
      </li>
    </ul>
    
    <div class="big-title">展品详情</div>
    <div class="detail" v-html="p.details"></div>

  </div>
</template>

<script>
import Btn from '@/components/Button/Btn.vue'
import { getProductDetail } from '@/api/seller.js'


export default {
  name: '',
  components:{Btn},
  data(){
    return {
      sid:this.$route.params.sid,
      pid:this.$route.params.pid,
      previewIdx:0,
      p:{},
      imglist:[]
    }
  },
  created(){
    console.log(this.$route);
    this.getDetail();
  },
  methods:{
    changeImg(e){
      const idx = e.currentTarget.dataset.idx*1;
      this.previewIdx = idx;
    },
    zoom(e){
      // const index = e.currentTarget.dataset.idx;
      this.$store.commit("zoom/setIdx",this.previewIdx);
      this.$store.commit("zoom/setList",this.imglist);
      this.$store.commit("zoom/setVisible",true);
    },
    getDetail(){
      getProductDetail(this.sid,this.pid).then(res=>{
        this.p = res;
        let zooms = res.atlas.splice(0,4).map((res,index)=>{
          return {picture:res};
        })
        this.imglist = zooms;
      })
    }
  }
}
</script>

<style scoped>

.btn-box>div{display:flex;}
.btn-box>div .main-button{width:26vw; height:3.28vw; margin:1vw auto 0 auto; font-size:1.1vw;}

.con{padding:2vw 1.5vw; background:#f7f7f7; min-height: calc(100vh - 17vw - 16vw);}
.breadcrumb{font-size:1vw; color:#666; margin-bottom:0.5vw;}
.breadcrumb>a{text-decoration:underline;}
.breadcrumb>a:hover{color:#e70031;}
.breadcrumb>span{margin:0 0.3vw;}

.flexbox{display:flex;}
.flexbox .left{display:flex;}
.flexbox .left .preview{flex:0 0 32vw; border:1px solid #eee; background:#fff;}
.flexbox .left .preview,
.flexbox .left .preview .img-box{width:32vw; height:32vw; position:relative; overflow:hidden;}
.flexbox .left .preview .img-box{display:flex;}
.flexbox .left .preview .img-box img{max-width:32vw; max-height:32vw; margin:auto;}
.flexbox .left .preview .img-box .zoom{position:absolute; right:0; width:2vw; height:2vw; background:rgba(0,0,0,.2); display:flex; cursor:pointer;}
.flexbox .left .preview .img-box .zoom>i{margin:auto; font-size:1.1vw;}

.flexbox .left ul{flex:0 0 auto; border:1px solid #eee; margin-left:0.5vw; padding:0 0.6vw;}
.flexbox .left ul li{box-sizing:border-box; border:1px solid #eee; width:7.6vw; height:7.6vw; background:#fff; margin-bottom:0.5vw; display:flex; cursor:pointer; overflow:hidden;}
.flexbox .left ul li.active{border:1px solid #e70031;}
.flexbox .left ul li:nth-last-of-type(1){margin-bottom:0;}
.flexbox .left ul img{box-sizing:border-box; width:7.3vw; height:7.3vw; object-fit:cover; margin:auto;}

.flexbox .right{flex:0 0 26vw; margin-left:1vw;}
.flexbox .right .title{font-size:2vw; font-weight:bold; margin-bottom:0.5vw;}
.flexbox .right .desp{font-size:1.2vw; color:#666; height:20vw; overflow-y:auto;}

.big-title{font-size:2vw; font-weight:bold; padding:2vw 0;}

.box2{display:flex; flex-wrap: wrap; font-size:0;}
.box2 li{flex:0 0 41.5vw; width:41.5vw; height:2.8vw; line-height:2.8vw; font-size:0.9vw; border-bottom:1px solid #eee;}
.box2 li>span:nth-of-type(1){color:#999; display:inline-block; width: 8vw;}
.box2 li>span:nth-of-type(2){color:#222;}

.detail{font-size:1.5vw;}


@media (max-width:991px){
.con{padding:3vw 2vw; }
.breadcrumb{font-size:3.6vw; color:#666; margin-bottom:2vw; margin-top:1vw;}
.breadcrumb>span{margin:0 0.9vw;}

.flexbox{display:flex; flex-wrap:wrap;}
.flexbox .left .preview{flex:0 0 74vw;}
.flexbox .left .preview,
.flexbox .left .preview .img-box{width:74vw; height:74vw; }
.flexbox .left .preview .img-box img{max-width:74vw; max-height:74vw;}
.flexbox .left .preview .img-box .zoom{width:6vw; height:6vw;}
.flexbox .left .preview .img-box .zoom>i{font-size:3.5vw;}

.flexbox .left ul{margin-left:1.4vw; }
.flexbox .left ul li{width:18vw; height:18vw;}
.flexbox .left ul img{width:18vw; height:18vw; }
.flexbox .right{margin-left:0; margin-top:2vw;}


.big-title{font-size:5vw; font-weight:bold; padding:4vw 0;}
.box2 li{flex:0 0 94vw; width:94vw; height:9vw; line-height:9vw; font-size:3.6vw;}
.box2 li>span:nth-of-type(1){color:#999; display:inline-block; width:35vw;}

.flexbox .right{flex:0 0 96vw; margin-left:0vw;}
.flexbox .right .title{font-size:4vw; margin:2vw;}
.flexbox .right .desp{font-size:3.6vw; height:auto; overflow-y:auto;}
.btn-box{margin:4vw 0;}

.btn-box>div .main-button{width:65vw; height:10vw; margin:2vw auto 0 auto; font-size:3.4vw; line-height: 5.5vw;}

.detail{font-size:3.6vw; line-height: 5.5vw;}
}
</style>